module.exports = __webpack_public_path__ + "static/face_01-d8fbc630948aff9203289ded27e06b05.jpg";